import PrivacyPolicy from '@/api/resources/privacyPolicy';

const state = {
  privacyPolicy: null,
};

const getters = {
  getPrivacyPolicy: (state) => state.privacyPolicy,
};

const actions = {
  getCurrentPrivacyPolicy({ commit }) {
    PrivacyPolicy.current().then((response) => {
      commit('setPrivacyPolicy', response);
    });
  },
};

const mutations = {
  setPrivacyPolicy($state, payload) {
    const stateCopy = $state;
    stateCopy.privacyPolicy = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
